import type { FieldPack } from '../../../../core/fields/types';
import { FieldType } from '../../../../core/fields/types';

/**
 * Compliance pack — framework violations, evidence artifacts, audit
 * status. Applies to security-gated resources (IAM, KMS, SG, S3, RDS).
 */
export const networkComplianceFieldPack: FieldPack = {
  id: 'network-compliance',
  name: 'Compliance',
  description: 'Framework violations, evidence, audit trail',
  version: '1.0.0',
  dependencies: ['network-base', 'network-security'],
  fields: [
    {
      id: 'frameworks',
      label: 'Compliance Frameworks',
      type: FieldType.MULTI_SELECT,
      tags: ['compliance'],
      priority: 100,
      options: [
        { value: 'soc2', label: 'SOC 2' },
        { value: 'iso-27001', label: 'ISO 27001' },
        { value: 'hipaa', label: 'HIPAA' },
        { value: 'pci-dss', label: 'PCI DSS' },
        { value: 'gdpr', label: 'GDPR' },
        { value: 'fedramp', label: 'FedRAMP' },
        { value: 'nist-csf', label: 'NIST CSF' },
      ],
      sensitivity: 'internal',
    },
    {
      id: 'frameworkViolations',
      label: 'Active Violations',
      type: FieldType.NUMBER,
      tags: ['compliance'],
      priority: 95,
      sensitivity: 'internal',
    },
    {
      id: 'evidenceStatus',
      label: 'Evidence Status',
      type: FieldType.SELECT,
      tags: ['compliance'],
      priority: 90,
      options: [
        { value: 'none', label: 'Not Collected' },
        { value: 'pending', label: 'Pending Review' },
        { value: 'approved', label: 'Approved' },
        { value: 'stale', label: 'Stale' },
      ],
      sensitivity: 'internal',
    },
    {
      id: 'lastAuditDate',
      label: 'Last Audit Date',
      type: FieldType.DATE,
      tags: ['compliance'],
      priority: 85,
      sensitivity: 'internal',
    },
    {
      id: 'dataClassification',
      label: 'Data Classification',
      type: FieldType.SELECT,
      tags: ['compliance'],
      priority: 80,
      options: [
        { value: 'public', label: 'Public' },
        { value: 'internal', label: 'Internal' },
        { value: 'confidential', label: 'Confidential' },
        { value: 'restricted', label: 'Restricted' },
      ],
      sensitivity: 'internal',
    },
    {
      id: 'piiPresent',
      label: 'Contains PII',
      type: FieldType.BOOLEAN,
      tags: ['compliance'],
      priority: 75,
      sensitivity: 'internal',
    },
    {
      id: 'residencyRegion',
      label: 'Data Residency Region',
      type: FieldType.TEXT,
      tags: ['compliance'],
      priority: 70,
      placeholder: 'eu-west-1',
      sensitivity: 'internal',
    },
  ],
};
